/**
 * Form
 *
 * L'état initial du formulaire de recherche.
 */
export const defaultFields = {};

export const availableFields = [];
